import React from "react";
import { Card } from "@atlassiansox/microscopekit";
import { isEmpty } from "lodash";
import { SteadyStateView } from "../../../../../components";
export var SteadyStatesList = function (_a) {
    var steadyStates = _a.steadyStates, onEdit = _a.onEdit, onDelete = _a.onDelete;
    return (React.createElement(React.Fragment, null, !isEmpty(steadyStates) ? (steadyStates.map(function (steadyState, index) { return (React.createElement(SteadyStateView, { steadyState: steadyState, edit: onEdit, delete: onDelete, key: steadyState.probeAction + "-" + index })); })) : (React.createElement(Card, null,
        React.createElement("p", null, "No stop conditions added")))));
};
